// ============================================================
//  SPIELER — Firestore-Subcollection "teams/{teamId}/spieler"
//  Kader-Verwaltung pro Team. "foto" ist eine Storage-URL (string),
//  hochgeladen über den bestehenden fotoHochladen()-Helper.
// ============================================================
import {
  collection,
  doc,
  getDocs,
  query,
  orderBy,
  addDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

function spielerCollection(teamId) {
  return collection(db, "teams", teamId, "spieler");
}

export async function fetchSpieler(teamId) {
  const q = query(spielerCollection(teamId), orderBy("sortierung", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function createSpieler(teamId, daten) {
  const ref = await addDoc(spielerCollection(teamId), daten);
  return ref.id;
}

export async function updateSpieler(teamId, spielerId, daten) {
  await updateDoc(doc(db, "teams", teamId, "spieler", spielerId), daten);
}

export async function deleteSpieler(teamId, spielerId) {
  await deleteDoc(doc(db, "teams", teamId, "spieler", spielerId));
}
